export const environment = {
  production: false,
  apiBaseUrl: "https://staging.api.subscrib.ly",
  websiteUrl: "https://qa.subscrib.ly",
  firebaseConfig: {
    apiKey: "AIzaSyASVBrC970Nx6RxB35fPFfXjoWkNce-6mM",
    authDomain: "subscribly-staging-5eb52.firebaseapp.com",
    projectId: "subscribly-staging-5eb52",
    storageBucket: "subscribly-staging-5eb52.firebasestorage.app",
    messagingSenderId: "887092894551",
    appId: "1:887092894551:web:b6e6eb19f4a0558b1fbc12",
    measurementId: "G-C013NLD6P8"
  },
  recaptchaSiteKey: "6Le1Y7YrAAAAAKjpDJLjjEPvTrVSPJvowh_x4BNt",
};
